import React, { useEffect } from "react";
import { X } from "lucide-react";
import useBodyScrollLock from "@/hooks/useBodyScrollLock";

/**
 * Reusable industrial modal shell with scroll lock + Esc-to-close + click-outside.
 * Use anywhere a modal is needed. Internal content scrolls; background is locked.
 */
export default function Modal({
  title,
  onClose,
  children,
  maxWidth = "max-w-md",
  testId = "modal",
}) {
  useBodyScrollLock(true);
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose && onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div data-testid={testId}
      className="fixed inset-0 z-50 bg-black/70 flex items-end md:items-center justify-center p-0 md:p-6"
      onClick={onClose}>
      <div className={`bg-background brutal-card w-full md:${maxWidth} max-h-[92vh] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b-2 border-foreground dark:border-safety-yellow p-4 md:p-5 sticky top-0 bg-background">
          <div className="font-heading text-2xl">{title}</div>
          <button onClick={onClose} data-testid={`${testId}-close`}
            className="h-12 w-12 border-2 border-foreground dark:border-safety-yellow hover:bg-safety-yellow hover:text-black inline-flex items-center justify-center">
            <X className="w-5 h-5" strokeWidth={3} />
          </button>
        </div>
        <div className="p-5 md:p-6">{children}</div>
      </div>
    </div>
  );
}
